import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ErrorService } from './error.service';

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    private apiUrl = environment.baseUrl;

    // ✅ getter — reads token fresh on every request
    private get httpOptions() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token') || ''
            })
        };
    }

    private get httpFileOptions() {
        return {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('token') || ''
            })
        };
    }

    constructor(private http: HttpClient, private errorService: ErrorService) { }

    getRequest(endpoint: string) {
        return this.http.get(this.apiUrl + endpoint, this.httpOptions).pipe(
            catchError((err) => this.errorService.handleError(err))
        );
    }

    postRequest(endpoint: string, data: any) {
        return this.http.post(this.apiUrl + endpoint, data, this.httpOptions).pipe(
            catchError((err) => this.errorService.handleError(err))
        );
    }

    putRequest(endpoint: string, data: any) {
        return this.http.put(this.apiUrl + endpoint, data, this.httpOptions).pipe(
            catchError((err) => this.errorService.handleError(err))
        );
    }

    deleteRequest(endpoint: string) {
        return this.http.delete(this.apiUrl + endpoint, this.httpOptions).pipe(
            catchError((err) => this.errorService.handleError(err))
        );
    }

    postFileRequest(endpoint: string, data: any) {
        return this.http.post(this.apiUrl + endpoint, data, this.httpFileOptions).pipe(
            catchError((err) => this.errorService.handleError(err))
        );
    }
}